/**
 * SubscriptionCancelPage Component
 * 
 * Page shown when user cancels Stripe checkout.
 * NOTE: Behavior copied from legacy App.js, do not change without regression testing.
 * 
 * @component
 * @param {Object} props
 * @param {Function} props.onRetry - Callback to retry payment
 * @param {Function} props.onContinue - Callback to continue without subscribing
 */

import React from 'react';
import { XCircle } from 'lucide-react';

function SubscriptionCancelPage({ onRetry, onContinue }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-orange-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h2>
        <p className="text-gray-600 mb-6">Your subscription was not completed. You can try again or continue with your free trial.</p>
        <div className="space-y-3">
          <button onClick={onRetry} className="btn-bawarchi-primary w-full">Try Again</button>
          <button onClick={onContinue} className="btn-bawarchi-secondary w-full">Continue to Dashboard</button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCancelPage;